module.exports = __webpack_public_path__ + "img/cluster-36-advert-square.fe140425.svg";